import { render, staticRenderFns } from "./index-pc.vue?vue&type=template&id=7083c320&scoped=true"
import script from "./index-pc.vue?vue&type=script&lang=js"
export * from "./index-pc.vue?vue&type=script&lang=js"
import style0 from "./index-pc.vue?vue&type=style&index=0&id=7083c320&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7083c320",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default,CommonButton: require('/builds/wj/fe/wenjuan-homesite/components/common/button.vue').default,CommonSvg: require('/builds/wj/fe/wenjuan-homesite/components/common/svg.vue').default})
